import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"window, timeline, feed, posts"} maskId="square-filled-radius-0-stroke-1-IconWindow"><path d="M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM20 9H4V4H20V9ZM9 6H18V7H9V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWindow;
